import { createSelector } from 'reselect';

const selector = (state, projectId) => {
  return state.submissions.items.filter(i => i.project_id === projectId)
                              .asMutable({ deep: true });
}

export default createSelector(
  [selector], result => result
)



// WEBPACK FOOTER //
// ./src/selectors/submissions-selector.js